import React from 'react'
import { isMobile } from '../../helpers/mobileresize/Mobileresize'
import WebViewDeal from './web/ViewDeal'
import MobileViewDeal from './mobile/ViewDeal'

const index = () =>{
    if(isMobile){
        return(
            <div>
                <MobileViewDeal />
            </div>
        )
    }else{
        return(
            <div>
                <WebViewDeal/>
            </div>
        )
    }
}

export default index